"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.observeJobGroupCreator = exports.observeJobCreator = void 0;
var Observable = require("zen-observable");
var job_manager_1 = require("../job-manager");
var job_group_1 = require("./job-group");
function observeJobCreator(configuration, httpClient) {
    var jobManager = new job_manager_1.JobManager(configuration, httpClient);
    function observeJob(createJob, pollingInterval) {
        if (pollingInterval === void 0) { pollingInterval = 500; }
        return new Observable(function (observer) {
            var pollJob = function (updatedJob) {
                if (updatedJob.isError()) {
                    observer.error(updatedJob);
                    return;
                }
                observer.next(updatedJob);
                if (updatedJob.isSuccess()) {
                    observer.complete();
                    return;
                }
                if (updatedJob.isWaiting()) {
                    setTimeout(function () {
                        fetchJob(updatedJob);
                    }, pollingInterval);
                }
            };
            var onFailure = function (error) {
                observer.error(error);
            };
            function fetchJob(job) {
                jobManager.getJob(job.id).then(pollJob).catch(onFailure);
            }
            createJob().then(pollJob).catch(onFailure);
        });
    }
    return observeJob;
}
exports.observeJobCreator = observeJobCreator;
exports.observeJobGroupCreator = function (configuration, httpClient) {
    var jobManager = new job_manager_1.JobManager(configuration, httpClient);
    return function (createJobGroup, pollingInterval) {
        if (pollingInterval === void 0) { pollingInterval = 500; }
        return new Observable(function (observer) {
            var pollJobGroup = function (updatedJobGroup) {
                if (updatedJobGroup.isError()) {
                    observer.error(updatedJobGroup);
                    return;
                }
                observer.next(updatedJobGroup);
                if (updatedJobGroup.isSuccess()) {
                    observer.complete();
                    return;
                }
                if (updatedJobGroup.isWaiting()) {
                    setTimeout(function () {
                        fetchJobGroup(updatedJobGroup);
                    }, pollingInterval);
                }
            };
            var onFailure = function (error) {
                observer.error(error);
            };
            function fetchJobGroup(jobGroup) {
                jobManager
                    .getJobGroup(jobGroup.groupId)
                    .then(function (jobs) {
                    return new job_group_1.JobGroup({
                        groupId: jobGroup.groupId,
                        jobs: jobs,
                    });
                })
                    .then(pollJobGroup)
                    .catch(onFailure);
            }
            createJobGroup().then(pollJobGroup).catch(onFailure);
        });
    };
};
//# sourceMappingURL=job-observable.js.map